import axios from 'axios';

const API_URL =
  import.meta.env.VITE_API_URL ||
  (import.meta.env.PROD ? '/api' : 'http://localhost:5001/api');

export const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

/** בסיס ה-API בלי /api — ל-OAuth redirects */
export function apiOrigin(): string {
  return API_URL.replace(/\/api\/?$/, '') || window.location.origin;
}

export function startGoogleLogin(): void {
  const returnUrl = `${window.location.origin}/google-auth`;
  window.location.href = `${apiOrigin()}/api/auth/google/start?redirect=${encodeURIComponent(returnUrl)}`;
}

api.interceptors.request.use((config) => {
  const url = String(config.url || '');
  const isPublicAuth = url.includes('/auth/login') || url.includes('/auth/register');
  if (!isPublicAuth) {
    const token = localStorage.getItem('wr_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401) {
      const url = String(error.config?.url || '');
      if (!url.includes('/auth/login')) {
        const sent = String(error.config?.headers?.Authorization || '').replace(/^Bearer\s+/i, '');
        const current = localStorage.getItem('wr_token');
        if (!sent || sent === current) {
          localStorage.removeItem('wr_token');
          if (
            !window.location.pathname.includes('/login') &&
            !window.location.pathname.includes('/google-auth')
          ) {
            window.location.href = '/login';
          }
        }
      }
    }
    return Promise.reject(error);
  },
);

/** ממיר נתיב שרת יחסי (כמו /api/public/places/photo?...) ל-URL מלא מול ה-API */
export function apiAbsoluteUrl(path: string): string {
  if (!path || /^https?:\/\//.test(path)) return path;
  const origin = API_URL.replace(/\/api\/?$/, '');
  return `${origin}${path}`;
}

export const publicApi = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

export type Account = {
  id: string;
  email: string;
  full_name: string | null;
  account_type: string;
};
